import React from "react";
// Material Imports
import { makeStyles } from "@material-ui/core/styles"; // Limitless imports

import DialogueNote from "../../dialogue-note/DialogueNote";
import CustomerDialogueWrapper from "./CustomerDialogueWrapper";
import CustomerDialogueBody from "./CustomerDialogueBody";
var useStyles = makeStyles({
  dialogueWrapper: {
    display: "flex"
  },
  dialogueNote: {
    display: "flex",
    width: "25%",
    justifyContent: "center",
    alignItems: "center"
  }
});

var CustomerDialogue = function CustomerDialogue(_ref) {
  var dialogue = _ref.dialogue,
      shouldAnimate = _ref.shouldAnimate;
  var classes = useStyles();
  var body = dialogue.body,
      contentModerated = dialogue.contentModerated;
  var hasDialogueNote = contentModerated && contentModerated.reason ? true : false;
  return /*#__PURE__*/React.createElement(CustomerDialogueWrapper, {
    dialogue: dialogue,
    shouldAnimate: shouldAnimate
  }, function () {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.dialogueWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.dialogueNote
    }, hasDialogueNote && /*#__PURE__*/React.createElement(DialogueNote, {
      note: contentModerated,
      position: "bottom-start"
    })), /*#__PURE__*/React.createElement(CustomerDialogueBody, {
      body: body
    }));
  });
};

export default CustomerDialogue;